"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1021],{

/***/ 4003:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BY": function() { return /* binding */ LP_HOLDERS_FEE; },
/* harmony export */   "Bq": function() { return /* binding */ ONE_DAY_UNIX; },
/* harmony export */   "MV": function() { return /* binding */ WEEKS_IN_YEAR; },
/* harmony export */   "OZ": function() { return /* binding */ MINIMUM_SEARCH_CHARACTERS; },
/* harmony export */   "Rr": function() { return /* binding */ PCS_V2_START; },
/* harmony export */   "Tb": function() { return /* binding */ ONE_HOUR_SECONDS; },
/* harmony export */   "hT": function() { return /* binding */ TREASURY_FEE; },
/* harmony export */   "om": function() { return /* binding */ TOTAL_FEE; },
/* harmony export */   "si": function() { return /* binding */ ITEMS_PER_INFO_TABLE_PAGE; },
/* harmony export */   "tE": function() { return /* binding */ TOKEN_BLACKLIST; },
/* harmony export */   "xy": function() { return /* binding */ BUYBACK_FEE; }
/* harmony export */ });
var MINIMUM_SEARCH_CHARACTERS = 2;
var WEEKS_IN_YEAR = 52.1429;
var TOTAL_FEE = 0.0025;
var LP_HOLDERS_FEE = 0.0017;
var TREASURY_FEE = 0.000225;
var BUYBACK_FEE = 0.000575;
var PCS_V2_START = 1619136000 // April 23, 2021, 12:00:00 AM
;
var ONE_DAY_UNIX = 86400 // 24h * 60m * 60s
;
var ONE_HOUR_SECONDS = 3600;
var ITEMS_PER_INFO_TABLE_PAGE = 10;
// These tokens are either incorrectly priced or have some other issues that spoil the query data
// None of them present any interest as they have almost 0 daily trade volume
var TOKEN_BLACKLIST = [
    // These ones are copied from v1 info
    "0x495c7f3a713870f68f8b418b355c085dfdc412c3",
    "0xc3761eb917cd790b30dad99f6cc5b4ff93c4f9ea",
    "0xe31debd7abff90b06bca21010dd860d8701fd901",
    "0xfc989fbb6b3024de5ca0144dc23c18a063942ac1",
    "0xe40fc6ff5f2895b44268fd2e1a421e07f567e007",
    "0xfd158609228b43aa380140b46fff3cdf9ad315de",
    "0xc00af6212fcf0e6fd3143e692ccd4191dc308bea",
    "0x205969b3ad459f7eba0dee07231a6357183d3fb6",
    "0x0bd67d358636fd7b0597724aa4f20beedbf3073a",
    "0xedf5d2a561e8a3cb5a846fbce24d2ccd88f50075",
    "0x702b0789a3d4dade1688a0c8b7d944e5ba80fc30",
    "0x041929a760d7049edaef0db246fa76ec975e90cc",
    "0xba098df8c6409669f5e6ec971ac02cd5982ac108",
    "0x1bbed115afe9e8d6e9255f18ef10d43ce6608d94",
    "0xe99512305bf42745fae78003428dcaf662afb35d",
    "0xbE609EAcbFca10F6E5504D39E3B113F808389056",
    "0x847daf9dfdc22d5c61c4a857ec8733ef5950e82e",
    "0xdbf8913dfe14536c0dae5dd06805afb2731f7e7b",
    // These ones are newly found
    "0xF1D50dB2C40b63D2c598e2A808d1871a40b1E653",
    "0x4269e4090ff9dfc99d8846eb0d42e67f01c3ac8b", 
];


/***/ }),

/***/ 71021:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "jf": function() { return /* binding */ fetchPoolData; },
/* harmony export */   "l4": function() { return /* binding */ parsePoolData; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(10253);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7297);
/* harmony import */ var _vercel_path0_ejoedex_frontend_main_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _vercel_path0_ejoedex_frontend_main_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_vercel_path0_ejoedex_frontend_main_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var graphql_request__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(28687);
/* harmony import */ var graphql_request__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(graphql_request__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var utils_graphql__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(75509);
/* harmony import */ var utils_getChangeForPeriod__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(19683);
/* harmony import */ var utils_getLpFeesAndApr__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(2385);
/* harmony import */ var utils_getDeltaTimestamps__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(79900);
/* harmony import */ var views_Info_hooks_useBlocksFromTimestamps__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(79566);
/* harmony import */ var views_Info_utils_infoDataHelpers__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(40393);
/* eslint-disable no-param-reassign */ 





function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)([
        "\n      query pools {\n        now: ",
        "\n        oneDayAgo: ",
        "\n        twoDaysAgo: ",
        "\n        oneWeekAgo: ",
        "\n        twoWeeksAgo: ",
        "\n      }\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}








/**
 * Data for displaying pool tables (on multiple pages, used throughout the site)
 * Note: Don't try to refactor it to use variables, server throws error if blocks passed as undefined variable
 * only works if its hard-coded into query string
 */ var POOL_AT_BLOCK = function(block, pools) {
    var blockString = block ? "block: {number: ".concat(block, "}") : "";
    var addressesString = '["'.concat(pools.join('","'), '"]');
    return "pairs(\n    where: { id_in: ".concat(addressesString, " }\n    ").concat(blockString, "\n    orderBy: trackedReserveBNB\n    orderDirection: desc\n  ) {\n    id\n    reserve0\n    reserve1\n    reserveUSD\n    volumeUSD\n    token0Price\n    token1Price\n    token0 {\n      id\n      symbol\n      name\n    }\n    token1 {\n      id\n      symbol\n      name\n    }\n  }");
};
var fetchPoolData = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_vercel_path0_ejoedex_frontend_main_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(block24h, block48h, block7d, block14d, poolAddresses) {
        var query, data;
        return _vercel_path0_ejoedex_frontend_main_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    query = (0,graphql_request__WEBPACK_IMPORTED_MODULE_2__.gql)(_templateObject(), POOL_AT_BLOCK(null, poolAddresses), POOL_AT_BLOCK(block24h, poolAddresses), POOL_AT_BLOCK(block48h, poolAddresses), POOL_AT_BLOCK(block7d, poolAddresses), POOL_AT_BLOCK(block14d, poolAddresses));
                    _ctx.next = 4;
                    return utils_graphql__WEBPACK_IMPORTED_MODULE_4__/* .infoClient.request */ .dQ.request(query);
                case 4:
                    data = _ctx.sent;
                    return _ctx.abrupt("return", {
                        data: data,
                        error: false
                    });
                case 8:
                    _ctx.prev = 8;
                    _ctx.t0 = _ctx["catch"](0);
                    console.error("Failed to fetch pool data", _ctx.t0);
                    return _ctx.abrupt("return", {
                        error: true
                    });
                case 12:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                8
            ]
        ]);
    }));
    return function fetchPoolData(block24h, block48h, block7d, block14d, poolAddresses) {
        return _ref.apply(this, arguments);
    };
}();
// Transforms pools into "0xADDRESS: { ...PoolFields }" format and cast strings to numbers
var parsePoolData = function(pairs) {
    if (!pairs) {
        return {};
    }
    return pairs.reduce(function(accum, poolData) {
        var volumeUSD = poolData.volumeUSD, reserveUSD = poolData.reserveUSD, reserve0 = poolData.reserve0, reserve1 = poolData.reserve1, token0Price = poolData.token0Price, token1Price = poolData.token1Price;
        accum[poolData.id] = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, poolData), {
            volumeUSD: parseFloat(volumeUSD),
            reserveUSD: parseFloat(reserveUSD),
            reserve0: parseFloat(reserve0),
            reserve1: parseFloat(reserve1),
            token0Price: parseFloat(token0Price),
            token1Price: parseFloat(token1Price)
        });
        return accum;
    }, {});
};
/**
 * Fetch top pools by liquidity
 */ var usePoolDatas = function(poolAddresses) {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)({
        error: false
    }), fetchState = ref[0], setFetchState = ref[1];
    var ref1 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,utils_getDeltaTimestamps__WEBPACK_IMPORTED_MODULE_10__/* .getDeltaTimestamps */ .z)(), 4), t24h = ref1[0], t48h = ref1[1], t7d = ref1[2], t14d = ref1[3];
    var ref2 = (0,views_Info_hooks_useBlocksFromTimestamps__WEBPACK_IMPORTED_MODULE_5__/* .useBlocksFromTimestamps */ .Z)([
        t24h,
        t48h,
        t7d,
        t14d
    ]), blocks = ref2.blocks, blockError = ref2.error;
    var ref3 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(blocks !== null && blocks !== void 0 ? blocks : [], 4), block24h = ref3[0], block48h = ref3[1], block7d = ref3[2], block14d = ref3[3];
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(function() {
        var fetch = function() {
            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_vercel_path0_ejoedex_frontend_main_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                var ref, error, data, formattedPoolData, formattedPoolData24h, formattedPoolData48h, formattedPoolData7d, formattedPoolData14d, formatted;
                return _vercel_path0_ejoedex_frontend_main_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.next = 2;
                            return fetchPoolData(block24h.number, block48h.number, block7d.number, block14d.number, poolAddresses);
                        case 2:
                            ref = _ctx.sent;
                            error = ref.error;
                            data = ref.data;
                            if (error) {
                                setFetchState({
                                    error: true
                                });
                            } else {
                                formattedPoolData = parsePoolData(data === null || data === void 0 ? void 0 : data.now);
                                formattedPoolData24h = parsePoolData(data === null || data === void 0 ? void 0 : data.oneDayAgo);
                                formattedPoolData48h = parsePoolData(data === null || data === void 0 ? void 0 : data.twoDaysAgo);
                                formattedPoolData7d = parsePoolData(data === null || data === void 0 ? void 0 : data.oneWeekAgo);
                                formattedPoolData14d = parsePoolData(data === null || data === void 0 ? void 0 : data.twoWeeksAgo);
                                formatted = poolAddresses.reduce(function(accum, address) {
                                    // Undefined data is possible if pool is brand new and didn't exist one day ago or week ago.
                                    var current = formattedPoolData[address];
                                    var oneDay = formattedPoolData24h[address];
                                    var twoDays = formattedPoolData48h[address];
                                    var week = formattedPoolData7d[address];
                                    var twoWeeks = formattedPoolData14d[address];
                                    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,utils_getChangeForPeriod__WEBPACK_IMPORTED_MODULE_11__/* .getChangeForPeriod */ .T)(current === null || current === void 0 ? void 0 : current.volumeUSD, oneDay === null || oneDay === void 0 ? void 0 : oneDay.volumeUSD, twoDays === null || twoDays === void 0 ? void 0 : twoDays.volumeUSD), 2), volumeUSD = ref[0], volumeUSDChange = ref[1];
                                    var ref1 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,utils_getChangeForPeriod__WEBPACK_IMPORTED_MODULE_11__/* .getChangeForPeriod */ .T)(current === null || current === void 0 ? void 0 : current.volumeUSD, week === null || week === void 0 ? void 0 : week.volumeUSD, twoWeeks === null || twoWeeks === void 0 ? void 0 : twoWeeks.volumeUSD), 2), volumeUSDWeek = ref1[0], volumeUSDChangeWeek = ref1[1];
                                    var liquidityUSD = current ? current.reserveUSD : 0;
                                    var liquidityUSDChange = (0,views_Info_utils_infoDataHelpers__WEBPACK_IMPORTED_MODULE_12__/* .getPercentChange */ .Y)(current === null || current === void 0 ? void 0 : current.reserveUSD, oneDay === null || oneDay === void 0 ? void 0 : oneDay.reserveUSD);
                                    var liquidityToken0 = current ? current.reserve0 : 0;
                                    var liquidityToken1 = current ? current.reserve1 : 0;
                                    var ref2 = (0,utils_getLpFeesAndApr__WEBPACK_IMPORTED_MODULE_13__/* .getLpFeesAndApr */ .z)(volumeUSD, volumeUSDWeek, liquidityUSD), totalFees24h = ref2.totalFees24h, totalFees7d = ref2.totalFees7d, lpFees24h = ref2.lpFees24h, lpFees7d = ref2.lpFees7d, lpApr7d = ref2.lpApr7d;
                                    if (current) {
                                        accum[address] = {
                                            address: address,
                                            token0: {
                                                address: current.token0.id,
                                                name: current.token0.name,
                                                symbol: current.token0.symbol
                                            },
                                            token1: {
                                                address: current.token1.id,
                                                name: current.token1.name,
                                                symbol: current.token1.symbol
                                            },
                                            token0Price: current.token0Price,
                                            token1Price: current.token1Price,
                                            volumeUSD: volumeUSD,
                                            volumeUSDChange: volumeUSDChange,
                                            volumeUSDWeek: volumeUSDWeek,
                                            volumeUSDChangeWeek: volumeUSDChangeWeek,
                                            totalFees24h: totalFees24h,
                                            totalFees7d: totalFees7d,
                                            lpFees24h: lpFees24h,
                                            lpFees7d: lpFees7d,
                                            lpApr7d: lpApr7d,
                                            liquidityUSD: liquidityUSD,
                                            liquidityUSDChange: liquidityUSDChange,
                                            liquidityToken0: liquidityToken0,
                                            liquidityToken1: liquidityToken1
                                        };
                                    }
                                    return accum;
                                }, {});
                                setFetchState({
                                    data: formatted,
                                    error: false
                                });
                            }
                        case 6:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function fetch() {
                return _ref.apply(this, arguments);
            };
        }();
        var allBlocksAvailable = (block24h === null || block24h === void 0 ? void 0 : block24h.number) && (block48h === null || block48h === void 0 ? void 0 : block48h.number) && (block7d === null || block7d === void 0 ? void 0 : block7d.number) && (block14d === null || block14d === void 0 ? void 0 : block14d.number);
        if (poolAddresses.length > 0 && allBlocksAvailable && !blockError) {
            fetch();
        }
    }, [
        poolAddresses,
        block24h,
        block48h,
        block7d,
        block14d,
        blockError
    ]);
    return fetchState;
};
/* harmony default export */ __webpack_exports__["ZP"] = (usePoolDatas);


/***/ }),

/***/ 12937:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "z": function() { return /* binding */ getBlocksFromTimestamps; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7297);
/* harmony import */ var _vercel_path0_ejoedex_frontend_main_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _vercel_path0_ejoedex_frontend_main_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_vercel_path0_ejoedex_frontend_main_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var lodash_orderBy__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(75472);
/* harmony import */ var lodash_orderBy__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lodash_orderBy__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var graphql_request__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(28687);
/* harmony import */ var graphql_request__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(graphql_request__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _views_Info_utils_infoQueryHelpers__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(75126);
/* harmony import */ var _config_constants_endpoints__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(85906);



function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)([
        "query blocks {\n    ",
        "\n  }"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var getBlockSubqueries = function(timestamps) {
    return timestamps.map(function(timestamp) {
        return "t".concat(timestamp, ":blocks(first: 1, orderBy: timestamp, orderDirection: desc, where: { timestamp_gt: ").concat(timestamp, ", timestamp_lt: ").concat(timestamp + 600, " }) {\n      number\n    }");
    });
};
var blocksQueryConstructor = function(subqueries) {
    return (0,graphql_request__WEBPACK_IMPORTED_MODULE_3__.gql)(_templateObject(), subqueries);
};
/**
 * @notice Fetches block objects for an array of timestamps.
 * @param {Array} timestamps
 */ var getBlocksFromTimestamps = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_vercel_path0_ejoedex_frontend_main_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(timestamps) {
        var sortDirection, skipCount, fetchedData, blocks, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, key, _args = arguments;
        return _vercel_path0_ejoedex_frontend_main_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    sortDirection = _args.length > 1 && _args[1] !== void 0 ? _args[1] : "desc", skipCount = _args.length > 2 && _args[2] !== void 0 ? _args[2] : 500;
                    if (!((timestamps === null || timestamps === void 0 ? void 0 : timestamps.length) === 0)) {
                        _ctx.next = 3;
                        break;
                    }
                    return _ctx.abrupt("return", []);
                case 3:
                    _ctx.next = 5;
                    return (0,_views_Info_utils_infoQueryHelpers__WEBPACK_IMPORTED_MODULE_4__/* .multiQuery */ .L)(blocksQueryConstructor, getBlockSubqueries(timestamps), _config_constants_endpoints__WEBPACK_IMPORTED_MODULE_5__/* .BLOCKS_CLIENT */ .I0, skipCount);
                case 5:
                    fetchedData = _ctx.sent;
                    blocks = [];
                    if (!fetchedData) {
                        _ctx.next = 26;
                        break;
                    }
                    _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    _ctx.prev = 9;
                    // eslint-disable-next-line no-restricted-syntax
                    for(_iterator = Object.keys(fetchedData)[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        key = _step.value;
                        if (fetchedData[key].length > 0) {
                            blocks.push({
                                timestamp: key.split("t")[1],
                                number: parseInt(fetchedData[key][0].number, 10)
                            });
                        }
                    }
                    _ctx.next = 17;
                    break;
                case 13:
                    _ctx.prev = 13;
                    _ctx.t0 = _ctx["catch"](9);
                    _didIteratorError = true;
                    _iteratorError = _ctx.t0;
                case 17:
                    _ctx.prev = 17;
                    _ctx.prev = 18;
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                case 20:
                    _ctx.prev = 20;
                    if (!_didIteratorError) {
                        _ctx.next = 23;
                        break;
                    }
                    throw _iteratorError;
                case 23:
                    return _ctx.finish(20);
                case 24:
                    return _ctx.finish(17);
                case 25:
                    return _ctx.abrupt("return", lodash_orderBy__WEBPACK_IMPORTED_MODULE_2___default()(blocks, function(block) {
                        return block.number;
                    }, sortDirection));
                case 26:
                    return _ctx.abrupt("return", blocks);
                case 27:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                9,
                13,
                17,
                25
            ],
            [
                18,
                ,
                20,
                24
            ]
        ]);
    }));
    return function getBlocksFromTimestamps(timestamps) {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 19683:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ getChangeForPeriod; }
/* harmony export */ });
/* harmony import */ var _views_Info_utils_infoDataHelpers__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(40393);

/**
 * Given current value and value 1 and 2 periods (e.g. 1day + 2days, 1week - 2weeks) returns the amount change for latest period
 * and percentage change compared to the previous period.
 * @param valueNow - current value
 * @param valueOnePeriodAgo - value 1 period ago (e.g. 1 day or 1 week ago), period unit must be same as valueTwoPeriodsAgo
 * @param valueTwoPeriodsAgo - value 2 periods ago (e.g. 2 days or 2 weeks ago), period unit must be same as valueOnePeriodAgo
 * @returns amount change for the latest period and percentage change compared to previous period
 */ var getChangeForPeriod = function(valueNow, valueOnePeriodAgo, valueTwoPeriodsAgo) {
    var currentPeriodAmount = (0,_views_Info_utils_infoDataHelpers__WEBPACK_IMPORTED_MODULE_0__/* .getAmountChange */ .D)(valueNow, valueOnePeriodAgo);
    var previousPeriodAmount = (0,_views_Info_utils_infoDataHelpers__WEBPACK_IMPORTED_MODULE_0__/* .getAmountChange */ .D)(valueOnePeriodAgo, valueTwoPeriodsAgo);
    var percentageChange = (0,_views_Info_utils_infoDataHelpers__WEBPACK_IMPORTED_MODULE_0__/* .getPercentChange */ .Y)(currentPeriodAmount, previousPeriodAmount);
    return [
        currentPeriodAmount,
        percentageChange
    ];
};


/***/ }),

/***/ 79900:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "z": function() { return /* binding */ getDeltaTimestamps; }
/* harmony export */ });
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28401);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(18717);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7069);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85899);

/**
 * Returns UTC timestamps for 24h ago, 48h ago, 7d ago and 14d ago relative to current date and time
 */ var getDeltaTimestamps = function() {
    var utcCurrentTime = (0,date_fns__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(new Date()) * 1000;
    var t24h = (0,date_fns__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,date_fns__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,date_fns__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(utcCurrentTime, 1)));
    var t48h = (0,date_fns__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,date_fns__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,date_fns__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(utcCurrentTime, 2)));
    var t7d = (0,date_fns__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,date_fns__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,date_fns__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(utcCurrentTime, 1)));
    var t14d = (0,date_fns__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,date_fns__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,date_fns__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(utcCurrentTime, 2)));
    return [
        t24h,
        t48h,
        t7d,
        t14d
    ];
};


/***/ }),

/***/ 2385:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "z": function() { return /* binding */ getLpFeesAndApr; }
/* harmony export */ });
/* harmony import */ var _config_constants_info__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4003);

var getLpFeesAndApr = function(volumeUSD, volumeUSDWeek, liquidityUSD) {
    var totalFees24h = volumeUSD * _config_constants_info__WEBPACK_IMPORTED_MODULE_0__/* .TOTAL_FEE */ .om;
    var totalFees7d = volumeUSDWeek * _config_constants_info__WEBPACK_IMPORTED_MODULE_0__/* .TOTAL_FEE */ .om;
    var lpFees24h = volumeUSD * _config_constants_info__WEBPACK_IMPORTED_MODULE_0__/* .LP_HOLDERS_FEE */ .BY;
    var lpFees7d = volumeUSDWeek * _config_constants_info__WEBPACK_IMPORTED_MODULE_0__/* .LP_HOLDERS_FEE */ .BY;
    var lpApr7d = liquidityUSD > 0 ? volumeUSDWeek * _config_constants_info__WEBPACK_IMPORTED_MODULE_0__/* .LP_HOLDERS_FEE */ .BY * _config_constants_info__WEBPACK_IMPORTED_MODULE_0__/* .WEEKS_IN_YEAR */ .MV * 100 / liquidityUSD : 0;
    return {
        totalFees24h: totalFees24h,
        totalFees7d: totalFees7d,
        lpFees24h: lpFees24h,
        lpFees7d: lpFees7d,
        lpApr7d: lpApr7d !== Infinity ? lpApr7d : 0
    };
};


/***/ }),

/***/ 75509:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "dQ": function() { return /* binding */ infoClient; },
/* harmony export */   "vA": function() { return /* binding */ getGQLHeaders; }
/* harmony export */ });
/* unused harmony exports infoServerClient, bitQueryServerClient */
/* harmony import */ var config_constants_endpoints__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85906);
/* harmony import */ var graphql_request__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(28687);
/* harmony import */ var graphql_request__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(graphql_request__WEBPACK_IMPORTED_MODULE_1__);
/* provided dependency */ var process = __webpack_require__(34155);


// Extra headers
// Mostly for dev environment
// No production env check since production preview might also need them
var getGQLHeaders = function(endpoint) {
    if (endpoint === config_constants_endpoints__WEBPACK_IMPORTED_MODULE_0__/* .INFO_CLIENT */ .JY) {
        return {
            "X-Sf": process.env.NEXT_PUBLIC_SF_HEADER || // hack for inject CI secret on window
            ( true && // @ts-ignore
            window.sfHeader)
        };
    }
    return undefined;
};
var infoClient = new graphql_request__WEBPACK_IMPORTED_MODULE_1__.GraphQLClient(config_constants_endpoints__WEBPACK_IMPORTED_MODULE_0__/* .INFO_CLIENT */ .JY, {
    headers: getGQLHeaders(config_constants_endpoints__WEBPACK_IMPORTED_MODULE_0__/* .INFO_CLIENT */ .JY)
});
var infoServerClient = new graphql_request__WEBPACK_IMPORTED_MODULE_1__.GraphQLClient(config_constants_endpoints__WEBPACK_IMPORTED_MODULE_0__/* .INFO_CLIENT */ .JY, {
    headers: {
        "X-Sf": process.env.SF_HEADER
    },
    timeout: 5000
});
var bitQueryServerClient = new graphql_request__WEBPACK_IMPORTED_MODULE_1__.GraphQLClient("https://graphql.bitquery.io", {
    headers: {
        // only server, no `NEXT_PUBLIC` not going to expose in client
        "X-API-KEY": process.env.BIT_QUERY_HEADER
    },
    timeout: 5000
});


/***/ }),

/***/ 261:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

var requestWithTimeout = function(graphQLClient, request, variables) {
    var timeout = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 30000;
    return Promise.race([
        variables ? graphQLClient.request(request, variables) : graphQLClient.request(request),
        new Promise(function(_, reject) {
            setTimeout(function() {
                reject(new Error("Request timed out after ".concat(timeout, " milliseconds")));
            }, timeout);
        }), 
    ]);
};
/* harmony default export */ __webpack_exports__["Z"] = (requestWithTimeout);


/***/ }),

/***/ 79566:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useBlocksFromTimestamps; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47568);
/* harmony import */ var _vercel_path0_ejoedex_frontend_main_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _vercel_path0_ejoedex_frontend_main_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_vercel_path0_ejoedex_frontend_main_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var utils_getBlocksFromTimestamps__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12937);




/**
 * for a given array of timestamps, returns block entities
 * @param timestamps
 * @param sortDirection
 * @param skipCount
 */ var useBlocksFromTimestamps = function(timestamps) {
    var sortDirection = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "desc", skipCount = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1000;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(), blocks = ref[0], setBlocks = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), error = ref1[0], setError = ref1[1];
    var timestampsString = JSON.stringify(timestamps);
    var blocksString = blocks ? JSON.stringify(blocks) : undefined;
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var fetchData = function() {
            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_vercel_path0_ejoedex_frontend_main_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                var timestampsArray, result;
                return _vercel_path0_ejoedex_frontend_main_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            timestampsArray = JSON.parse(timestampsString);
                            _ctx.next = 3;
                            return (0,utils_getBlocksFromTimestamps__WEBPACK_IMPORTED_MODULE_2__/* .getBlocksFromTimestamps */ .z)(timestampsArray, sortDirection, skipCount);
                        case 3:
                            result = _ctx.sent;
                            if (result.length === 0) {
                                setError(true);
                            } else {
                                setBlocks(result);
                            }
                        case 5:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function fetchData() {
                return _ref.apply(this, arguments);
            };
        }();
        var blocksArray = blocksString ? JSON.parse(blocksString) : undefined;
        if (!blocksArray && !error) {
            fetchData();
        }
    }, [
        blocksString,
        error,
        skipCount,
        sortDirection,
        timestampsString
    ]);
    return {
        blocks: blocks,
        error: error
    };
};


/***/ }),

/***/ 40393:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ getAmountChange; },
/* harmony export */   "Y": function() { return /* binding */ getPercentChange; }
/* harmony export */ });
/**
 * Get increase/decrease of value compared to the previous value (e.g. 24h volume compared to 24h volume the day before )
 * @param valueNow - more recent value
 * @param valueBefore - value to compare with
 */ var getAmountChange = function(valueNow, valueBefore) {
    if (valueNow && valueBefore) {
        return valueNow - valueBefore;
    }
    if (valueNow) {
        return valueNow;
    }
    return 0;
};
/**
 * Get increase/decrease of value compared to the previous value as a percentage
 * @param valueNow - more recent value
 * @param valueBefore - value to compare with
 */ var getPercentChange = function(valueNow, valueBefore) {
    if (valueNow && valueBefore) {
        return (valueNow - valueBefore) / valueBefore * 100;
    }
    return 0;
};


/***/ }),

/***/ 75126:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ multiQuery; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _vercel_path0_ejoedex_frontend_main_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _vercel_path0_ejoedex_frontend_main_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_vercel_path0_ejoedex_frontend_main_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var graphql_request__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(28687);
/* harmony import */ var graphql_request__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(graphql_request__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var utils_graphql__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(75509);
/* harmony import */ var utils_requestWithTimeout__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(261);






/**
 * Helper function to get large amount GraphQL subqueries
 * @param queryConstructor constructor function that combines subqueries
 * @param subqueries individual queries
 * @param endpoint GraphQL endpoint
 * @param skipCount how many subqueries to fire at a time
 * @returns
 */ var multiQuery = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_vercel_path0_ejoedex_frontend_main_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(queryConstructor, subqueries, endpoint) {
        var skipCount, fetchedData, allFound, skip, client, end, subqueriesSlice, result, _args = arguments;
        return _vercel_path0_ejoedex_frontend_main_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    skipCount = _args.length > 3 && _args[3] !== void 0 ? _args[3] : 1000;
                    fetchedData = {};
                    allFound = false;
                    skip = 0;
                    client = new graphql_request__WEBPACK_IMPORTED_MODULE_1__.GraphQLClient(endpoint, {
                        headers: (0,utils_graphql__WEBPACK_IMPORTED_MODULE_2__/* .getGQLHeaders */ .vA)(endpoint)
                    });
                    _ctx.prev = 5;
                case 6:
                    if (allFound) {
                        _ctx.next = 18;
                        break;
                    }
                    end = subqueries.length;
                    if (skip + skipCount < subqueries.length) {
                        end = skip + skipCount;
                    }
                    subqueriesSlice = subqueries.slice(skip, end);
                    _ctx.next = 12;
                    return (0,utils_requestWithTimeout__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(client, queryConstructor(subqueriesSlice));
                case 12:
                    result = _ctx.sent;
                    fetchedData = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, fetchedData, result);
                    allFound = Object.keys(result).length < skipCount || skip + skipCount > subqueries.length;
                    skip += skipCount;
                    _ctx.next = 6;
                    break;
                case 18:
                    return _ctx.abrupt("return", fetchedData);
                case 21:
                    _ctx.prev = 21;
                    _ctx.t0 = _ctx["catch"](5);
                    console.error("Failed to fetch info data", _ctx.t0);
                    return _ctx.abrupt("return", null);
                case 25:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                5,
                21
            ]
        ]);
    }));
    return function multiQuery(queryConstructor, subqueries, endpoint) {
        return _ref.apply(this, arguments);
    };
}();


/***/ })

}]);